export default __webpack_public_path__ + "static/media/banner3.93f5de15.png";